import { render, staticRenderFns } from "./add_new_page.vue?vue&type=template&id=8f6f6c9e&scoped=true&"
import script from "./add_new_page.vue?vue&type=script&lang=js&"
export * from "./add_new_page.vue?vue&type=script&lang=js&"
import style0 from "./add_new_page.vue?vue&type=style&index=0&id=8f6f6c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6f6c9e",
  null
  
)

export default component.exports